<template>
  <v-container>
  <v-layout>
    <v-flex xs12 >
      <template v-if="member">
      <v-flex xs12 >
      <v-card >
          <v-card-title>
              <template v-if="member.profilepic">
                  <v-avatar
                  size="35" 
                  color="grey lighten-2"                                            
                  ><img v-bind:src="member.profilepic.fileurl"></v-avatar>                                          
              </template>
              <template v-else>
                  <v-icon>person</v-icon>
              </template>    
              
              <div class="headline pa-1">{{member.firstname}} {{member.lastname}}</div>
              <v-subheader @click="openFileDialog()" class="primary--text font-weight-bold caption"><v-icon>photo_camera</v-icon>Update Profile Photo</v-subheader>
                                <input ref="fileinput" style="position:absolute;top:-200px;" type="file" accept="image/*" @change="detectFiles($event.target.files)">
                                <img ref="image_preview" style="position:absolute;top:-900px;" src=""/>
                                <v-progress-linear
                                v-if="progressUpload>0"
                                :size="100"
                                :width="15"
                                :value="progressUpload"
                                color="primary lighten-1"
                                >
                                {{ progressUpload }}                                    
                                </v-progress-linear>                
          </v-card-title>                        
          <v-card-text>            


            <v-flex xs12>
            <v-list>
                <v-list-tile>
                    <v-layout row>
                    <v-flex xs3 class="profilekey caption font-weight-bold">
                        Email:
                    </v-flex>
                    <v-flex class="profilevalue caption" xs9 v-if="member.email">
                        {{member.email}}
                    </v-flex>  
                                            
                    </v-layout>
                </v-list-tile>
                <v-divider inset></v-divider>   
                <template  v-if="member.emailalts && member.emailalts.length>1">
                <v-list-tile v-for="emailalt in member.emailalts" v-bind:key="emailalt">
                    <v-layout row>
                    <v-flex xs3 class="profilekey caption font-weight-bold">
                        Alt Email:
                    </v-flex>
                    <v-flex class="profilevalue caption" xs9 v-if="emailalt">
                        {{emailalt}}
                    </v-flex>  
                                            
                    </v-layout>
                </v-list-tile>
                <v-divider inset></v-divider>
                </template>
                <v-list-tile>
                    <v-layout row>
                    <v-flex xs3 class="profilekey caption font-weight-bold">
                        Paypal Address:
                    </v-flex>
                    <v-flex class="profilevalue caption" xs9 v-if="member.email2">
                        {{member.email2}}
                    </v-flex>                                
                    </v-layout>
                </v-list-tile>    
                <v-divider inset></v-divider>                     
                <v-list-tile>
                    <v-layout row>
                    <v-flex xs3 class="profilekey caption font-weight-bold">
                        Phone:
                    </v-flex>
                    <v-flex class="profilevalue caption" xs9 v-if="member.phone">
                        {{member.phone}}
                    </v-flex>                                
                    </v-layout>
                </v-list-tile>    
                <v-divider inset></v-divider>                              
            </v-list>
            </v-flex>
            <v-flex>
                <v-btn color="primary" @click="syncLinkedInData('member')">
                    <v-icon>fab fa-linkedin</v-icon> &nbsp; Sync Linked In Career Profile
                </v-btn>
            </v-flex>
          </v-card-text>

      </v-card>
      </v-flex>
      <v-flex xs12 pt-3>

        <template v-if="member.linkedin && member.linkedin.headline">
        <v-expansion-panel>
            <v-expansion-panel-content
            key="linkedin"
            >
            <div slot="header">
                                <v-layout row>
                                    <v-flex xs2>
                        <v-avatar
                            size="35" 
                            color="grey lighten-2"                                            
                            ><img v-bind:src="member.linkedin.pictureUrl"></v-avatar>
                                    </v-flex>
                                    <v-flex xs10 class="font-weight-bold">
                            {{member.linkedin.headline}}
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12 class="caption primary--text lighten-2">
                                    {{member.linkedin.industry}}
                                    </v-flex>
                                </v-layout>                                

            </div>
                <v-card  v-if="member.linkedin && member.linkedin.headline">
                    <v-card-title>
                        <v-layout column>
                            <v-flex class="caption grey--text">
                                Summary: {{member.linkedin.summary}}
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text pa-0 class="caption">


                        <template>
                        <v-expansion-panel pa-0>
                            <v-expansion-panel-content
                            key="innerExpanse"
                            >
                            <div slot="header">
                                <v-layout column>
                                    <v-flex xs12 class="text-xs-center body font-weight-bold primary--text ">
                                        POSITION HISTORY
                                    </v-flex>
                                </v-layout>          
                                
                            </div>
                            <v-card flat>
                                <v-card-text>
                                    <v-layout column>
                                        <template v-for="pos in member.linkedin.positions.values" >
                                        <v-flex :key="pos.id">
                                            <v-layout pt-2 row>
                                                <v-flex ml-3 class="flexlabel" xs3>
                                                    {{pos.title}}
                                                </v-flex>
                                                <v-flex class="flexvalue" ml-2 xs9>
                                                    {{pos.summary}}
                                                </v-flex>                      
                                            </v-layout>
                                        </v-flex>
                                        <v-divider :key="'v-divider-' + pos.id"></v-divider>
                                        </template>
                                    </v-layout>            

                                </v-card-text>
                            </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        </template>


                    </v-card-text>
                </v-card>

            </v-expansion-panel-content>
        </v-expansion-panel>
        </template>


      </v-flex>
      <v-flex xs12 >
      <v-card v-if="member.verifiers">
          <v-card-title>
              <v-alert
                :value="true"
                type="success"
              >
                Your Account Has Been Verified
              </v-alert>  
          </v-card-title>
          <v-card-text>
              <!--<div class="caption">Remember, your account must be verified by at least 2 registered chapter members before your access is authorized.</div>-->
          </v-card-text>
      </v-card>
      </v-flex>

      <v-flex xs12>

      <template v-if="member.verifiers">
        <v-subheader>{{member.verifiers.length}} out of 2 members have vouched</v-subheader>
        <v-expansion-panel>
          <v-expansion-panel-content
            v-for="(v,i) in member.verifiers"
            :key="i"
          >
            <div slot="header">{{v.name}}</div>
            <v-card>
              <v-card-text>


                <v-flex xs12>
                <v-list>
                    <v-list-tile>
                        <v-layout row>
                        <v-flex xs3 class="profilekey caption font-weight-bold">
                            Date:
                        </v-flex>
                        <v-flex class="profilevalue caption" xs9 v-if="v.dateverified">
                            {{v.dateverified}}
                        </v-flex>  
                                                
                        </v-layout>
                    </v-list-tile>
                    <v-divider inset></v-divider>   
                    <v-list-tile>
                        <v-layout row>
                        <v-flex xs3 class="profilekey caption font-weight-bold">
                            Line:
                        </v-flex>
                        <v-flex class="profilevalue caption" xs9 v-if="v.line">
                            {{v.line}}
                        </v-flex>                                
                        </v-layout>
                    </v-list-tile>    
                    <v-divider inset></v-divider>                     
                    <v-list-tile>
                        <v-layout row>
                        <v-flex xs3 class="profilekey caption font-weight-bold">
                            Method:
                        </v-flex>
                        <v-flex class="profilevalue caption" xs9 v-if="v.methodofverification">
                            {{v.methodofverification}}
                        </v-flex>                                
                        </v-layout>
                    </v-list-tile>    
                    <v-divider inset></v-divider>                              
                </v-list>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </template>


 
      </v-flex>        
      </template>
      <template v-else-if="userVrequestDoc">
      <v-flex xs12 >
      <v-card >
          <v-card-title>
              <template v-if="userVrequestDoc.photoUrl">
                  <v-avatar
                  size="35" 
                  color="grey lighten-2"                                            
                  ><img v-bind:src="userVrequestDoc.photoUrl"></v-avatar>                                          
              </template>
              <template v-else>
                  <v-icon>person</v-icon>
              </template>    
              
              <div class="headline pa-1">{{userVrequestDoc.name}}</div>
              
          </v-card-title>                        
          <v-card-text>            

            <v-flex xs12>
            <v-list>
                <v-list-tile>
                    <v-layout row>
                    <v-flex xs3 class="profilekey caption font-weight-bold">
                        Email:
                    </v-flex>
                    <v-flex class="profilevalue caption" xs9 v-if="userVrequestDoc.email">
                        {{userVrequestDoc.email}}
                    </v-flex>  
                                            
                    </v-layout>
                </v-list-tile>
                <v-divider inset></v-divider>   
                 
                <v-list-tile>
                    <v-layout row>
                    <v-flex xs3 class="profilekey caption font-weight-bold">
                        Phone:
                    </v-flex>
                    <v-flex class="profilevalue caption" xs9 v-if="userVrequestDoc.phone">
                        {{userVrequestDoc.phone}}
                    </v-flex>                                
                    </v-layout>
                </v-list-tile>    
                <v-divider inset></v-divider>                              
            </v-list>
            </v-flex>
            <v-flex>
                <v-btn color="primary" @click="syncLinkedInData('vrequest')">
                    <v-icon>fab fa-linkedin</v-icon> &nbsp; Sync Linked In Career Profile
                </v-btn>
            </v-flex>

          </v-card-text>

      </v-card>  
      </v-flex>


        <template v-if="userVrequestDoc.linkedin && userVrequestDoc.linkedin.headline">
        <v-flex xs12>
        <v-expansion-panel>
            <v-expansion-panel-content
            key="linkedin"
            >
            <div slot="header">
                                <v-layout row>
                                    <v-flex xs2>
                        <v-avatar
                            size="35" 
                            color="grey lighten-2"                                            
                            ><img v-bind:src="userVrequestDoc.linkedin.pictureUrl"></v-avatar>
                                    </v-flex>
                                    <v-flex xs10 class="font-weight-bold">
                            {{userVrequestDoc.linkedin.headline}}
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12 class="caption primary--text lighten-2">
                                    {{userVrequestDoc.linkedin.industry}}
                                    </v-flex>
                                </v-layout>                                

            </div>
                <v-card  v-if="userVrequestDoc.linkedin && userVrequestDoc.linkedin.headline">
                    <v-card-title>
                        <v-layout column>
                            <v-flex class="caption grey--text">
                                Summary: {{userVrequestDoc.linkedin.summary}}
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text pa-0 class="caption">


                        <template>
                        <v-expansion-panel pa-0>
                            <v-expansion-panel-content
                            key="innerExpanse"
                            >
                            <div slot="header">
                                <v-layout column>
                                    <v-flex xs12 class="text-xs-center body font-weight-bold primary--text ">
                                        POSITION HISTORY
                                    </v-flex>
                                </v-layout>          
                                
                            </div>
                            <v-card flat>
                                <v-card-text>
                                    <v-layout column>
                                        <template v-for="pos in userVrequestDoc.linkedin.positions.values" >
                                        <v-flex :key="pos.id">
                                            <v-layout pt-2 row>
                                                <v-flex ml-3 class="flexlabel" xs3>
                                                    {{pos.title}}
                                                </v-flex>
                                                <v-flex class="flexvalue" ml-2 xs9>
                                                    {{pos.summary}}
                                                </v-flex>                      
                                            </v-layout>
                                        </v-flex>
                                        <v-divider :key="'v-divider-' + pos.id"></v-divider>
                                        </template>
                                    </v-layout>            

                                </v-card-text>
                            </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        </template>


                    </v-card-text>
                </v-card>

            </v-expansion-panel-content>
        </v-expansion-panel>
        </v-flex>
        </template>



      <v-flex xs12 >
      <v-card >
                      
          <v-card-text>            
              
          <v-card>
              <v-card-text>
                <v-subheader class="title pa-0" >Claims to be:</v-subheader>

                <v-flex xs12>
                <v-list>
                    <v-list-tile>
                        <v-layout row>
                        <v-flex xs3 class="profilekey caption font-weight-bold">
                            Member Name:
                        </v-flex>
                        <v-flex class="profilevalue caption" xs9 v-if="userVrequestDoc">
                            {{userVrequestDoc.memberfirstname}} {{userVrequestDoc.memberlastname}}
                        </v-flex>  
                                                
                        </v-layout>
                    </v-list-tile>
                    <v-divider inset></v-divider>   
                    
                    <v-list-tile>
                        <v-layout row>
                        <v-flex xs3 class="profilekey caption font-weight-bold">
                            Member Line:
                        </v-flex>
                        <v-flex class="profilevalue caption" xs9 v-if="userVrequestDoc">
                            {{userVrequestDoc.memberlineid}}
                        </v-flex>                                
                        </v-layout>
                    </v-list-tile>    
                    <v-divider inset></v-divider>                              
                </v-list>
                </v-flex>
        
              </v-card-text>
          </v-card>

          </v-card-text>

      </v-card>  
      </v-flex>   

      <v-flex xs12 >
      <v-card >
          <v-card-title>
              <v-alert
                :value="true"
                type="warning"
              >
                Your Account is Pending Verification
              </v-alert>  
              <div class="subheading">{{userVrequestDoc.verifiers.length}} out of 2 members have vouched</div>
          </v-card-title>
          <v-card-text>
              <v-subheader class="caption">Remember, your account must be verified by at least 2 registered chapter members before your access is authorized.</v-subheader>
          </v-card-text>
      </v-card>
      </v-flex>

      <v-flex xs12>

      <template v-if="userVrequestDoc.verifiers">
        <v-subheader>{{userVrequestDoc.verifiers.length}} out of 2 members have vouched</v-subheader>
        <v-expansion-panel>
          <v-expansion-panel-content
            v-for="(v,i) in userVrequestDoc.verifiers"
            :key="i"
          >
            <div slot="header">{{v.name}}</div>
            <v-card>
              <v-card-text>



                <v-flex xs12>
                <v-list>
                    <v-list-tile>
                        <v-layout row>
                        <v-flex xs3 class="profilekey caption font-weight-bold">
                            Date:
                        </v-flex>
                        <v-flex class="profilevalue caption" xs9 v-if="v.dateverified">
                            {{v.dateverified}}
                        </v-flex>  
                                                
                        </v-layout>
                    </v-list-tile>
                    <v-divider inset></v-divider>   
                    <v-list-tile>
                        <v-layout row>
                        <v-flex xs3 class="profilekey caption font-weight-bold">
                            Line:
                        </v-flex>
                        <v-flex class="profilevalue caption" xs9 v-if="v.line">
                            {{v.line}}
                        </v-flex>                                
                        </v-layout>
                    </v-list-tile>    
                    <v-divider inset></v-divider>                     
                    <v-list-tile>
                        <v-layout row>
                        <v-flex xs3 class="profilekey caption font-weight-bold">
                            Method:
                        </v-flex>
                        <v-flex class="profilevalue caption" xs9 v-if="v.methodofverification">
                            {{v.methodofverification}}
                        </v-flex>                                
                        </v-layout>
                    </v-list-tile>    
                    <v-divider inset></v-divider>                              
                </v-list>
                </v-flex>

              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </template>
      </v-flex>      
      </template>







    </v-flex>
  </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase'
import moment from 'moment'
const DATEFORMAT = "ddd, MMM D h:mmA"

  export default {
      data(){
          return{
            progressUpload: 0,
            file: File,
            fileIsImage: false,
            filename: null,
            filetype: null,
            filepath: null,
            uploadTask: ''               
          }

      },
    computed: {
      user () {
        return this.$store.getters.user
      },
      userVrequestDoc () {
          var uvrd = this.$store.getters.userVrequestDoc
          if(uvrd && uvrd.verifiers){
            uvrd.verifiers = uvrd.verifiers.map(v=>{
                v.dateverified = moment(v.dateverified).format(DATEFORMAT)
                return v
            })
          }

        return uvrd
      },      
      member () {
          var memb = this.$store.getters.member
          if(memb && memb.verifiers){
            memb.verifiers = memb.verifiers.map(v=>{
                v.dateverified = moment(v.dateverified).format(DATEFORMAT)
                return v
            })  
          }
        
        return memb
      }
    },
    watch:{
        uploadTask: function(value) {
            value.on('state_changed', sp => {
                this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
            }, 
            null, 
            () => {
                value.snapshot.ref.getDownloadURL().then(downloadURL => {
                    //console.log('downloadURL', downloadURL)
                    this.$emit('url', downloadURL)

                    this.$store.dispatch('addFileToUploadHistory', {member: this.member, type: 'profilepic', fileurl: downloadURL, filepath: this.filepath}).then(errmsg => {
                        //console.log('msg', errmsg)
                        if(errmsg && errmsg ==='failure'){
                            console.error('addFileToUploadHistory', errmsg) 
                        }else{
                            //console.log('successfully added file addFileToUploadHistory') 

                            if(this.fileIsImage){
                                
                                this.$store.dispatch('updateProfilePic', {member: this.member, fileurl: downloadURL, filename: this.filename , filetype: this.filetype, isImage: this.fileIsImage, filepath: this.filepath}).then(errmsg => {
                                    //console.log('msg', errmsg)
                                    if(errmsg && errmsg ==='failure'){
                                        console.error('updateProfilePic', errmsg) 
                                    }else{
                                        //console.log('successfully added file to post') 
                                        
                                    }
                                })                                   
                            } 
                            this.fileIsImage = false
                            this.filename = null
                            this.filetype = null
                            this.filepath = null

                        }
                    })                      

                })
            })
        }
    },
    methods:{
        openFileDialog: function (){
            var inputbutton = this.$refs.fileinput
            //console.log('inputbutton',inputbutton)
            inputbutton.click()

        },
      
        detectFiles: function (fileList) {
        Array.from(Array(fileList.length).keys()).map( x => {
            this.upload(fileList[x])
        })
        },   
        upload: function (file) {
            if(file.type.indexOf('image')>-1){
                this.fileIsImage = true
                var dataUrl = "";
                // Create an image
                var img = document.createElement("img");
                img.addEventListener('load', ()=> {
                // execute drawImage statements here
                   var canvas = document.createElement("canvas");
                    //var canvas = $("<canvas>", {"id":"testing"})[0];
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);            
                    // Set Width and Height
                    var MAX_WIDTH = 400;
                    var MAX_HEIGHT = 300;
                    var width = img.width;
                    var height = img.height;            
                    if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                    } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, width, height);            
                    //console.log('calling canvas',canvas)
                    dataUrl = canvas.toDataURL(file.type);                    
                    this.$refs.image_preview.src = dataUrl;    
                    //console.log('calling dataUrl', dataUrl)
                    this.filename = new Date().getTime() + '_' + file.name
                    this.filetype = file.type
                    this.filepath = this.member.org + '_' + this.member.chapter + '/profilepics/' +  this.filename

                    this.uploadTask = firebase.storage().ref(this.filepath).putString(dataUrl, 'data_url')
                }, false);            
                // Create a file reader
                var reader = new FileReader();
                // Set the image once loaded into file reader
                reader.onload = (e)=>
                {
                    //console.log('calling reader.onload  e', e)

                    img.src = e.target.result;
                    //console.log('calling reader.onload  img', img)                   
                }
                // Load files into file reader
                reader.readAsDataURL(file);               

            }
        },            
        /*    
        upload: function (file) {
            if(file.type.indexOf('image')>-1){
                this.fileIsImage = true
            }
            
            this.filename = this.member.member + '_' + new Date().getTime() + '_' + file.name
            this.filetype = file.type
            this.filepath = this.member.org + '_' + this.member.chapter + '/profilepics/' +  this.filename
            this.uploadTask = firebase.storage().ref(this.filepath).put(file);
        },
        */
        syncLinkedInData(synctype){
            var projectid='zzques-staging'
            if(process.env.NODE_ENV==='production'){
                projectid='zzques-2e9f8'
            }
                var popupQueryParams = '' 
            if(synctype==='member'){
                popupQueryParams = '?userid='+ this.member.userid
                popupQueryParams = popupQueryParams + '&usertype=' + synctype
                popupQueryParams =popupQueryParams + '&org='+ this.member.org
                popupQueryParams =popupQueryParams + '&chapter='+ this.member.chapter
                popupQueryParams =popupQueryParams + '&projectid='+ projectid                
                console.log('popupQueryParams ' + popupQueryParams)
                
            }else if(synctype==='vrequest'){
                var uvrd = this.$store.getters.userVrequestDoc
                popupQueryParams = '?userid='+ uvrd.userid
                popupQueryParams = popupQueryParams + '&usertype=' + synctype
                popupQueryParams =popupQueryParams + '&org='+ uvrd.memberorg
                popupQueryParams =popupQueryParams + '&chapter='+ uvrd.memberchapter
                popupQueryParams =popupQueryParams + '&projectid='+ projectid
                console.log('popupQueryParams ' + popupQueryParams)
            }

            window.open('popup.html' + popupQueryParams, 'name', 'height=585,width=400')

        }  

    }
  }
</script>

<style>
.flexlabel{
    font-weight: bold;

}
</style>